<sb-card [loading]="geoStatsloading" [singleHeight]="true">
  <div card-header>
    <div class="d-flex justify-content-start">
      <div class="mr-2">

      </div>
      <div class="mr-2">

      </div>
    </div>
  </div>
  <div card-body>
    <div *ngIf="geoStats && !geoStatsloading">
      <sb-polygon-edit-map [readOnly]="true" [nominatim]="false" [mapheight]="400" [centerPoint]="center" [points]="points"
                           [lineStrings]="lineStrings" [polygons]="polygons" [layers]="layers" [zoomControl]="false" [initialZoom]="7"
                           (initialPanReady)="showMap()" [roundedCorners]="true"></sb-polygon-edit-map>
    </div>
  </div>
</sb-card>
